"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_text = void 0;
exports.foundation_text = {
    family: {
        text_itauDisplay_family: 'Itau Display',
        text_itauText_family: 'Itau Text',
        text_itauIcon_family: 'Itau_Icons',
        text_robotoText_family: 'Roboto',
        text_firasansText_family: 'text_firasansText_family',
        text_exo2Text_family: 'Exo 2',
    },
    weight: {
        text_itauDisplay_weight_200: 200,
        text_itauDisplay_weight_400: 400,
        text_itauDisplay_weight_700: 700,
        text_itauDisplay_weight_900: 900,
        text_itauText_weight_200: 200,
        text_itauText_weight_400: 400,
        text_itauText_weight_700: 700,
        text_itauText_weight_900: 900,
        text_robotoText_weight_300: 300,
        text_robotoText_weight_400: 400,
        text_robotoText_weight_700: 700,
        text_robotoText_weight_900: 900,
        text_firasansText_weight_300: 300,
        text_firasansText_weight_400: 400,
        text_firasansText_weight_700: 700,
        text_firasansText_weight_900: 900,
        text_exo2Text_weight_300: 300,
        text_exo2Text_weight_400: 400,
        text_exo2Text_weight_700: 700,
        text_exo2Text_weight_900: 900,
    },
};
//# sourceMappingURL=global.js.map